<div class="container">
    <table mat-table [dataSource]="headers()" class="mat-elevation-z8">
        <!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on the row definition" -->

        <!-- Colonne 'Clé' -->
        <ng-container matColumnDef="key">
            <th mat-header-cell *matHeaderCellDef class="column-key">Clé</th>
            <td mat-cell *matCellDef="let element" class="column-key">{{ element.key }}</td>
        </ng-container>

        <!-- Colonne 'Valeur' -->
        <ng-container matColumnDef="value">
            <th mat-header-cell *matHeaderCellDef class="column-value">Valeur</th>
            <td mat-cell *matCellDef="let element" class="column-value">{{ element.value }}</td>
        </ng-container>

        <!-- Colonne 'Actions' -->
        <ng-container matColumnDef="actions" stickyEnd>
            <th mat-header-cell *matHeaderCellDef aria-label="column actions" class="action-column">
                <button mat-icon-button class="accent-button" [disabled]="disabled" (click)="onCreateHeader()" aria-label="Ajouter un header">
                    <mat-icon>add</mat-icon>
                </button>
            </th>
            <td mat-cell *matCellDef="let element">
                <button mat-icon-button [disabled]="disabled" [matMenuTriggerFor]="menu" [matMenuTriggerData]="{ element: element }" aria-label="Menu contextuel">
                    <mat-icon>more_vert</mat-icon>
                </button>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-menu #menu="matMenu">
        <ng-template matMenuContent let-element="element">
            <button mat-menu-item [disabled]="disabled" (click)="onEditHeader(element)">
                <mat-icon>edit</mat-icon>
                <span>Editer</span>
            </button>
            <button mat-menu-item [disabled]="disabled" (click)="onDeleteHeader(element)">
                <mat-icon>delete</mat-icon>
                <span>Supprimer</span>
            </button>
        </ng-template>
    </mat-menu>
</div>
